import gql from 'graphql-tag'

import { ObjectivesFragment } from './ObjectivesFragment'
import { PreferencesFragment } from './PreferencesFragment'
import { UserPlanFragment } from './UserPlanFragment'

export const UserFragment = gql`
  fragment UserFragment on User {
    id
    token
    should_receive_notifications
    notification_frequency
    preferences {
      ...PreferencesFragment
    }
    objectives {
      ...ObjectivesFragment
    }
    current_plan {
      ...UserPlanFragment
    }
    favorite_recipes {
      id
    }
    push_preferences {
      installIOS
      installAndroid
      notification
    }
    has_download_menu
  }
  ${PreferencesFragment}
  ${ObjectivesFragment}
  ${UserPlanFragment}
`
